import { DetailsExpertiseAttachmentActionTypes, DetailsExpertiseAttachmentState } from './types';
import { Reducer } from 'redux';
import { ActionType } from 'typesafe-actions';
import * as expertiseAttachmentActions from './actions';
export type ExpertiseAttachmentAction = ActionType<typeof expertiseAttachmentActions>;

const initialState: DetailsExpertiseAttachmentState = {
  expertiseAttachments: [],
  selectedAttachmentAmazonId: ''
};

const reducer: Reducer<DetailsExpertiseAttachmentState, ExpertiseAttachmentAction> = (state = initialState, action): DetailsExpertiseAttachmentState => {
  switch (action.type) {
    case DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS_SUCCESS: {
      return { ...state,
        expertiseAttachments: action.payload
      };
    }
    case DetailsExpertiseAttachmentActionTypes.RESET_STATE: {
      return initialState;
    }
    case DetailsExpertiseAttachmentActionTypes.SET_PREVIEW_AMAZON_ID: {
      return { ...state, selectedAttachmentAmazonId: action.payload.amazonId };
    }
    case DetailsExpertiseAttachmentActionTypes.FETCH_EXPERTISE_ATTACHMENTS_FAIL:
    default: {
      return state;
    }
  }
};

export { reducer as detailsExpertiseAttachmentReducer, initialState as detailsExpertiseAttachmentInitialState };
